import React from "react";
import linkedinIcon from "../../../assets/image/linkedin.svg";
import LocaleStrings from "@language";
import { useSocialMedia } from "@useSocialMedia";

function LinkedinButton({ onCompletion = (e) => {} }) {
  const { loading, handleLinkedInLogin } = useSocialMedia(onCompletion);

  return (
    <button
      onClick={handleLinkedInLogin}
      className={`LINKEDIN_BUTTON w-full h-10 px-4 py-2 gap-2 rounded-lg bg-[#0A66C2] flex justify-center items-center ${
        loading ? "animate-pulse" : ""
      }`}
      type="button"
    >
      <img src={linkedinIcon} alt="LinkedIn Icon" className="" />
      <div className="text-white text-sm font-medium text-nowrap">
        {LocaleStrings.kLinkedInloginButton}
      </div>
    </button>
  );
}

export default LinkedinButton;
